module.exports = __webpack_public_path__ + "img/model_mobile_bg_1.7568fb35.png";